import { useEffect, useRef } from "react";
import { formatIDR } from "../../../../utils/helpers/formatIDR";

const AnimatedCurrency = ({ value = 0, className = "" }) => {
  const numericValue = Number(value || 0);
  const previousValueRef = useRef(numericValue);
  const direction = numericValue >= previousValueRef.current ? "up" : "down";

  useEffect(() => {
    previousValueRef.current = numericValue;
  }, [numericValue]);

  return (
    <span
      key={numericValue}
      className={`pos-animated-currency is-${direction} ${className}`.trim()}
      data-testid="animated-currency">
      {formatIDR(numericValue)}
    </span>
  );
};

export default AnimatedCurrency;
